import { render, staticRenderFns } from "./UploadArea.vue?vue&type=template&id=1aaca10b&scoped=true&"
import script from "./UploadArea.vue?vue&type=script&lang=js&"
export * from "./UploadArea.vue?vue&type=script&lang=js&"
import style0 from "./UploadArea.vue?vue&type=style&index=0&id=1aaca10b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aaca10b",
  null
  
)

export default component.exports